import { Flex } from "@similarweb/ui-components/foundations";

import { CompetitorsChartWidget } from "../../shared/components/competitors-chart";
import { CompetitorsTable } from "../../shared/components/competitors-table";

export const CompetitorsReport = () => (
    <Flex
        flexDirection="column"
        gap="24px"
        data-automation="competitors-page-container"
        minHeight="1200px"
    >
        <CompetitorsChartWidget />
        <CompetitorsTable />
    </Flex>
);
